import user from './user'
import firebase from './firebase'

export default {
  user,
  firebase,
}
